'use strict';

angular.module('myConsultApp')
    .factory('BrowserService', function ($resource, ENV, Session, $window) {

        var browserService = {};

        browserService.openNewTab = function(){
		     var newTabWindow = $window.open();
		     return newTabWindow;
		}

		browserService.updateTabLocation = function(tabLocation, tab) {
		     if(!tabLocation){
		       tab.close();
		     }
		     tab.location.href = tabLocation;
		}

		return browserService;

});